import { postData } from "./axiosConfig"

export const login = async (body) => {
    return await postData('login', body)
}

export const register = async (body) => {
    return await postData('register', body)
}

export const forgotPassword = async (body) => {
    return await postData('/forgot-password', body)
}
export const resetNewPassword = async (body) => {
    return await postData('/reset-password', body)
}